<template>
	<v-container>
		<v-row justify="center" align="center">
			<v-col v-for="type in packagingTypes" :key="type.key" cols="auto">
				<PackagingCard :packaging-type="type" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { useStore } from '../../stores/store';
import PackagingCard from "./PackagingCard.vue";

export default {
	name: "PackagingSelection",
	components: {
		PackagingCard
	},
	setup() {
		const store = useStore()

		return {
			store
		}
	},
	computed: {
		packagingTypes() {
			return this.store.packagingTypes
		},
	}
}
</script>